import type { Theme } from '@mui/material';

// additional styles for drawer to fix it visibility during resizing
export const getDrawerStyles = (isOpen: boolean, theme: Theme) => ({
  visibility: isOpen ? 'unset' : 'hidden',
  transitionDelay: isOpen
    ? 'unset'
    : `${theme.transitions.duration.leavingScreen}ms`,
});
